import {createSelector} from 'reselect';

// Content redux state
const contentReducerSelector = state => state.content;

// Content Payload
const contentSelector = createSelector(
    contentReducerSelector,
    contentReducer => contentReducer.get('payload')
);

// Content is fetching
const contentIsFetchingSelector = createSelector(
    contentReducerSelector,
    contentReducer => contentReducer.get('isFetching')
);

// Content id
const contentIdSelector = createSelector(
    contentReducerSelector,
    contentReducer => contentReducer.get('contentId')
);

// Content type
const contentTypeSelector = createSelector(
    contentReducerSelector,
    contentReducer => contentReducer.get('contentType')
);

// Content error
const contentErrorSelector = createSelector(
    contentReducerSelector,
    contentReducer => contentReducer.get('error')
);

export {
    contentSelector,
    contentIsFetchingSelector,
    contentIdSelector,
    contentTypeSelector,
    contentErrorSelector
};